define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.EventType = void 0;
    var EventType;
    (function (EventType) {
        EventType["COM_CIPTEX_NOTIFIED_BOOKING_CREATED"] = "com.ciptex.notified.booking.created";
        EventType["COM_CIPTEX_NOTIFIED_BOOKING_UPDATED"] = "com.ciptex.notified.booking.updated";
        EventType["COM_CIPTEX_NOTIFIED_BOOKING_CANCELED"] = "com.ciptex.notified.booking.canceled";
        EventType["COM_CIPTEX_NOTIFIED_BOOKING_DELETED"] = "com.ciptex.notified.booking.deleted";
        EventType["COM_CIPTEX_NOTIFIED_BOOKING_COMPLETED"] = "com.ciptex.notified.booking.completed";
        EventType["COM_CIPTEX_NOTIFIED_CONFERENCE_CREATED"] = "com.ciptex.notified.conference.created";
        EventType["COM_CIPTEX_NOTIFIED_CONFERENCE_UPDATED"] = "com.ciptex.notified.conference.updated";
        EventType["COM_CIPTEX_NOTIFIED_CONFERENCE_DELETED"] = "com.ciptex.notified.conference.deleted";
        EventType["COM_CIPTEX_NOTIFIED_CONFERENCE_STARTED"] = "com.ciptex.notified.conference.started";
        EventType["COM_CIPTEX_NOTIFIED_CONFERENCE_ENDED"] = "com.ciptex.notified.conference.ended";
        EventType["COM_CIPTEX_NOTIFIED_PARTICIPANT_CREATED"] = "com.ciptex.notified.participant.created";
        EventType["COM_CIPTEX_NOTIFIED_PARTICIPANT_UPDATED"] = "com.ciptex.notified.participant.updated";
        EventType["COM_CIPTEX_NOTIFIED_PARTICIPANT_DELETED"] = "com.ciptex.notified.participant.deleted";
        EventType["COM_CIPTEX_NOTIFIED_PARTICIPANT_CONNECTED"] = "com.ciptex.notified.participant.connected";
        EventType["COM_CIPTEX_NOTIFIED_PARTICIPANT_DISCONNECTED"] = "com.ciptex.notified.participant.disconnected";
        EventType["COM_CIPTEX_NOTIFIED_PARTICIPANT_ACTIVITY_UPDATE"] = "com.ciptex.notified.participant.activity.update";
    })(EventType = exports.EventType || (exports.EventType = {}));
});
